module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "menu mxr-declination"
  }, [(_vm.product && _vm.product.productInfo) ? _vm._l((_vm.product.productInfo.declinations), function(declinaison, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.getProduct(declinaison.modelId)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": ("http://decathlon.fr/" + (declinaison.imgUrl)),
        "alt": "",
        "width": "36"
      }
    })])
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57a4b786"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductDeclination.vue
// module id = 456
// module chunks = 1